import { Snackbar } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useLocationQuery from '../../../hooks/useQuery';
import Spinner from '../../Shared/Spinner';
import TableContainer from '../../Shared/TableContainer';
import HealtheraTable from '../../Table/Table';
import prepareData from './prepareTableData';
import ReportsSelect from './ReportsSelect';

const ReportsTable = () => {
  const { data, error, fetching } = useSelector(
    (state) => state.dashboardReports,
  );
  const { query, changeLocationQuery } = useLocationQuery();
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);

  const { data: pharmacyData, pagination } = data || {};

  const handleRowsPerPageChange = useCallback(
    ({ target: { value } }) => {
      changeLocationQuery({
        ...query,
        limit: value,
        page: 0,
      });
    },
    [changeLocationQuery, query],
  );

  useEffect(() => {
    if (error) {
      setErrorSnackbarOpen(true);
    }
  }, [error]);

  const handleChangePage = (_, pageNumber) => {
    changeLocationQuery({
      ...query,
      page: pageNumber,
    });
  };

  return (
    <TableContainer>
        <ReportsSelect />
        {fetching ? (
          <Spinner />
        ) : pharmacyData ? (
          <HealtheraTable
            data={prepareData(pharmacyData)}
            displayPagination
            totalCount={pagination.total}
            page={+query.page || 0}
            rowsPerPage={+query.limit || 10}
            onRowsPerPageChange={handleRowsPerPageChange}
            onChangePage={handleChangePage}
            isLiveDashboard={true}
          />
        ) : null}
        <Snackbar
          open={errorSnackbarOpen}
          onClose={() => setErrorSnackbarOpen(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={4000}
          message={error}
        />
    </TableContainer>
  );
};

export default ReportsTable;
